import { Map } from 'immutable';
import { types as jobTypes } from '@saucelabs/sl-module-jobs';

import { types as jobContainerTypes } from './../job';
import * as actions from './actions';
import * as constants from './constants';
import * as types from './types';

const initialState = Map({
  files: Map(),
  status: constants.STATUS.LOADING,
  selectedFilename: '',
});

const fileReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SHOW_LOADER:
      return state.set('status', constants.STATUS.LOADING);
    case types.NO_FILES_AVAILABLE:
    case jobTypes.ASSET_GET.FAILURE:
    case jobContainerTypes.ASSETS_EXPIRED:
      return state.set('status', constants.STATUS.FAILURE);
    case types.ATTACH_FILE: {
      const files = state.get('files');
      const linesCount = actions.countLines(payload.data);
      const updatedFiles = files.set(
        payload.name,
        {
          data: payload.data,
          lines: linesCount,
          status: payload.status ?? constants.STATUS.SUCCESS,
        },
      );
      return state.withMutations((mutable) => {
        mutable.set('files', updatedFiles);
        mutable.set('status', constants.STATUS.SUCCESS);
      });
    }
    case types.EXCEED_FILE_SIZE: {
      const files = state.get('files');
      const updatedFiles = files.set(
        payload.name,
        { data: [], lines: 0, status: constants.STATUS.FAILURE },
      );
      return state.withMutations((mutable) => {
        mutable.set('files', updatedFiles);
        mutable.set('status', constants.STATUS.SUCCESS);
      });
    }
    case types.SELECT_FILE:
      return state.set('selectedFilename', payload);
    case types.CLEANUP:
      return initialState;
    case types.SELECT_RIGHT_PANEL_TAB:
      return state.set('activeRightPanelTab', payload);
    case types.SELECT_LEFT_PANEL_TAB:
      return state.set('activeLeftPanelTab', payload);
    default:
      return state;
  }
};

export default fileReducer;
export {
  initialState,
};
